"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amIFollowing = exports.requestFriendship = exports.clearUserData = exports.setUserData = exports.getUserData = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
exports.getUserData = (0, redux_saga_routines_1.createRoutine)('user-review/GET_USER_DATA');
exports.setUserData = (0, redux_saga_routines_1.createRoutine)('user-review/SET_USER_INFO');
exports.clearUserData = (0, redux_saga_routines_1.createRoutine)('user-review/CLEAR_USER_DATA');
exports.requestFriendship = (0, redux_saga_routines_1.createRoutine)('user-review/REQUEST_FRIENDSHIP');
exports.amIFollowing = (0, redux_saga_routines_1.createRoutine)('user-review/GET_FOLLOW_STATUS');
